import { async } from '@firebase/util';
import React, { useState } from 'react'
import { Form, FloatingLabel, Button, Card } from 'react-bootstrap';
import { toast, Toaster } from "react-hot-toast";
import { axiosOpen } from '../../api/axios';
import { useNavigate } from "react-router-dom";

const TechStack = () => {
    const companyId = localStorage.getItem('compId');
    const [techStackInput, setTechStackInput] = useState("");
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();
    const handleCloseForm = () => {navigate("/addportfolio")}
    const handleSubmit = (e) => {
        e.preventDefault();
        if (techStackInput.length === 0) {
            toast.error("Tech Stack is required");
            return;
        }
        setSaving(true);


        (async () => {
            debugger
            try {
                await axiosOpen.post('/api/singletechstack/createSingleTechStack', {
                    companyId: companyId,
                    techStack: techStackInput
                });
                debugger;
                setSaving(false);
                toast.success('Saved')
                setTimeout(() => { navigate("/portfolio", { replace: true }); }, 3000);
            } catch ({ response }) {
                toast.error(response.data.message);
                setSaving(false);
            }
        })()
    }

    return (
        <div className='wrapper'>
            <Toaster
                position="top-center"
            />
            <Card style={{ maxWidth: "600px", width: "100%", margin: "0 auto" }}>
                <Card.Header>
                    <Card.Title as="h5">Add Tech Stack</Card.Title>
                </Card.Header>
                <span className="close" onClick={handleCloseForm}>
                    X
                </span>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <fieldset>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Tech Stack"
                                className="mb-3"
                            >
                                <Form.Control type="text" placeholder="ReactJS" value={techStackInput} onChange={(e) => setTechStackInput(e.target.value)} />
                            </FloatingLabel>
                            <Button variant="primary" type="submit" disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
                        </fieldset>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}

export default TechStack